import { IEnkLoggedInUser } from "../auth/auth-interfaces"
import { TEnkUserInfo } from "./api-iwp-server"

export const loginResultToUser = (userInfo: TEnkUserInfo): IEnkLoggedInUser => {
  return {
    username: userInfo.username as string,
    displayname: userInfo.displayname as string,
    email: userInfo.emailaddress as string,
    groups:
      userInfo.groups.map((group) => ({
        id: group.groupId,
        description: group.description || "",
      })) || [],
    currentGroupId: (userInfo.groups || []).length > 0 ? userInfo.groups[0].groupId : -1,
    canUseModules: userInfo.roles
      ? userInfo.roles.split(",").map(Number).filter((n) => !isNaN(n))
      : [10, 80, 90],
    profilePicture: userInfo.profilePicture as string,
  }
}
